import React from 'react';
import backArrow from '../../assets/images/backArrow.svg'
import { BackWrapper } from './style';
import { useNavigate } from 'react-router-dom';
import { isEmpty } from 'lodash';

function Back({url}) {
    const navigate = useNavigate();
    const backPage = () =>{
        if(isEmpty(url)){
            navigate(-1);
        }else{
            navigate(url);
        }
        
    }
  return (
    <BackWrapper onClick={backPage} >
    <div className="img"></div>
		<span> Back</span>
		</BackWrapper>
  )
}

export default Back;